import { useState } from "react";
import { useStore } from "../store/home";
import Header from "./Header";
import Footer from "./Footer";
import Tooltip from "@mui/material/Tooltip";
import place from "../Images/placeHolder.png";
import ProductTile from "./ProductTile";
import { addCommaDecimal, deviceDetector, getCurrentDate } from "../commonFunction";
import { useNavigate, useSearchParams } from "react-router-dom";
import FindParts from "../commenComp/FindParts";
import { useNonPersistedStore } from "../store/NonPersistedStore";
import "./PartsDetail.css";
import SideMenu from "../commenComp/SideMenu";
import { useMutation, useQuery } from "@tanstack/react-query";
import PartsCatalog from "../commenComp/PartsCatalog";
import ShopComponent from "./ShopComponent";
import classnames from "classnames";
import { Modal } from "@mui/material";
import AddToCartPopUp from "./AddToCartPopUp";
import AddToShopPop from "./AddToShopPopUp";
import Carousal from "./Carousal";
import { Link } from "react-router-dom";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
// import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import Select from "react-select";
import {
  updateWishList,
  getPartDetail,
  addToCart,
  getMyCart,
} from "../api/posts";
import { ReactComponent as GreyShopList } from "../Images/greyShopList.svg";
import { ReactComponent as RedCart } from "../Images/redCart.svg";
import Loader from "../commenComp/Loader";
import { ReactComponent as Checkmark } from "../Images/checkMark.svg";
import { ReactComponent as Exclamation } from "../Images/exclamation.svg";
import { ReactComponent as Warning } from "../Images/warningIcon.svg";
import NumericInput from "react-numeric-input";
import { useEffect } from "react";
import { CircularProgress } from "@material-ui/core";
import { toast } from "react-toastify";
import { Box, Grid } from "@mui/material";
import commonMessages from "../commenComp/CommonMessages";
import { customStyles } from "../utils/ReactSelectCustomStyles";
import { useRef } from "react";
import { showErrorToast } from "../utils/Toaster";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatPartStatus } from "../utils/helperFunctions/numberFormat";

const PartsDetail = () => {
  const [searchParams] = useSearchParams();
  const [selected, setSelected] = useState(null);
  const [defaultSelected, setDefaultSelected] = useState("");
  const [show, setShow] = useState(false);
  const [load, setload] = useState(true);
  const [shopListPop, setShopListPop] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenShop, setIsModalOpenShop] = useState(false);
  const [varrientDropdown, setVarrientDropdown] = useState([]);
  const selectVarientRef = useRef();
  const {
    currentDevice,
    token,
    setKeyWord,
    isCurrentEngSet,
    userInfo,
    setKeyWordFinal,
    myProfile,
    globalcategoryIdCatalog,
    dealerId,
    setMyCartMini,
    setParID,
    trecord,
    offset,
    box,
    start,
    addToCartConfigs,
    setAddToCartConfigs,
  } = useStore();
  const data = {
    token: token,
    id: searchParams?.get("id"),
    dealerId: dealerId,
    currentEngine: isCurrentEngSet ? isCurrentEngSet.engineId : "",
  };
  const [partDetail, setPartDetail] = useState();
  const { setPof } = useNonPersistedStore();
  const tempShowCompatibleEngines = false; // Temporary flag to hide compatible engines section
  const mutation1 = useMutation((post) => getPartDetail(post), {
    mutationKey: "getPartDetail",
    method: "GET",
    onSuccess: (result) => {
      if(result?.data?.success){
        const obj = { data: result };
        setload(false);
        setPartDetail(obj);
      } else {
        setload(false);
        navigate({
          pathname: "/partNotFound",
        });
        setTimeout(() => {
          showErrorToast('Requested part does not exist')
        }, 200);
      }
    },
    onError: (error) => {
      // showErrorToast('Requested part does not exist')
      setload(false);
    },
  });
  const initialRender1 = useRef(true);
  useEffect(() => {
    if (initialRender1.current) {
      initialRender1.current = false;
      setParID(searchParams?.get("number"));
      const data = {
        token: token,
        number: searchParams?.get("number"),
        dealerId: dealerId,
        currentEngine: isCurrentEngSet ? isCurrentEngSet.engineId : "",
      };
      setload(true);
      window.scrollTo(0, 0);
      setpartData([]);
      mutation1.mutate(data);
    }
  }, []);
  // const partDetail = useQuery({
  //   queryKey: ["getPartDetail"],
  //   retry: 2,
  //   refetchOnWindowFocus: false,
  //   queryFn: () => getPartDetail(data),
  // });
  const [quantity, setQuantity] = useState(1);
  const handleInputChangeSelect = (event) => {
    let val = event;
    // Cap quantity at MAX_CONFIGS for parts with additionalInfo
    if (partData?.additionalInfoFlag && val > MAX_CONFIGS) {
      val = MAX_CONFIGS;
    }
    setQuantity(val);
  };
  const navigate = useNavigate();
  const [partData, setpartData] = useState();
  const [disableBut, setIsDiable] = useState(false);
  const [mes, setmes] = useState(false);
  const [addinfoText, setaddinfoText] = useState({});

  // --- Multi-configuration state ---
  const MAX_CONFIGS = 5;
  const [additionalConfigs, setAdditionalConfigs] = useState([]);
  const [configsInitialized, setConfigsInitialized] = useState(false);

  /** Creates an empty config object with all additionalInfo fields set to "" */
  const createEmptyConfig = (id) => {
    const fields = {};
    if (partData?.additionalInfo && partData.additionalInfo.length > 0) {
      partData.additionalInfo.forEach((fieldName) => {
        fields[fieldName] = "";
      });
    }
    return { id, fields };
  };

  /** Add a new configuration (max 5) */
  const handleAddConfig = () => {
    if (additionalConfigs.length >= MAX_CONFIGS) return;
    const nextId =
      additionalConfigs.length > 0
        ? Math.max(...additionalConfigs.map((c) => c.id)) + 1
        : 1;
    const newConfigs = [...additionalConfigs, createEmptyConfig(nextId)];
    setAdditionalConfigs(newConfigs);
    setQuantity(newConfigs.length);
  };

  /** Remove a configuration by id (must keep at least 1) */
  const handleRemoveConfig = (configId) => {
    if (additionalConfigs.length <= 1) return;
    const newConfigs = additionalConfigs.filter((c) => c.id !== configId);
    setAdditionalConfigs(newConfigs);
    setQuantity(newConfigs.length);
  };

  /** Update a single field inside a specific configuration */
  const handleConfigFieldChange = (configId, fieldName, value) => {
    setAdditionalConfigs((prev) =>
      prev.map((config) =>
        config.id === configId
          ? { ...config, fields: { ...config.fields, [fieldName]: value } }
          : config
      )
    );
  };

  /** Check if all configurations are fully valid */
  const areAllConfigsValid = () => {
    if (additionalConfigs.length === 0) return false;
    return additionalConfigs.every((config) =>
      Object.values(config.fields).every((v) => v && v.trim() !== "")
    );
  };
  useEffect(() => {
    setVarrientDropdown(partDetail?.data?.data?.varientDrodown);
    if (
      partDetail?.data?.data?.varientDrodown &&
      partDetail?.data?.data?.varientDrodown?.length > 1
    ) {
      if (partDetail?.data?.data?.varientDrodown[1].length === 0) {
        setIsDiable(true);
        setmes(true);
      }
    }
    partDetail?.data?.data?.data?.map((item, index) => {
      setpartData(partDetail?.data?.data?.data[0]);
      if (
        partDetail?.data?.data?.data[0] &&
        partDetail?.data?.data?.data[0]?.isDiscontinue?.status
      ) {
        navigate('/catalog')
        setTimeout(() => {
          showErrorToast('The requested part is discontinued')
        }, 500);
      }
      if (
        partDetail?.data?.data?.data[0] &&
        partDetail?.data?.data?.data[0].additionalInfoFlag
      ) {
        setIsDiable(true);
      }
    });
  }, [partDetail]);

  // Initialize first configuration when partData has additionalInfo
  // Initialize configurations: restore from persisted store if available, otherwise create empty
  useEffect(() => {
    if (
      partData?.additionalInfoFlag &&
      partData?.additionalInfo?.length > 0 &&
      !configsInitialized
    ) {
      const storedConfigs = addToCartConfigs?.[partData.partId];
      if (storedConfigs && storedConfigs.length > 0) {
        // Restore configs from persisted store (convert response format back to local format)
        const restoredConfigs = storedConfigs.map((config, index) => ({
          id: index + 1,
          fields: config.fields
            ? config.fields.reduce((acc, f) => {
                acc[f.title] = f.value || "";
                return acc;
              }, {})
            : {},
        }));
        setAdditionalConfigs(restoredConfigs);
        setQuantity(restoredConfigs.length);
      } else {
        setAdditionalConfigs([createEmptyConfig(1)]);
        setQuantity(1);
      }
      setConfigsInitialized(true);
    }
  }, [partData, configsInitialized]);

  // Sync config cards when quantity changes (only for additionalInfoFlag parts)
  useEffect(() => {
    if (!partData?.additionalInfoFlag || !configsInitialized) return;
    const target = Math.max(1, Math.min(quantity || 1, MAX_CONFIGS));
    if (additionalConfigs.length === target) return;

    if (target > additionalConfigs.length) {
      // Add configs to match quantity
      const newConfigs = [...additionalConfigs];
      let nextId = additionalConfigs.length > 0
        ? Math.max(...additionalConfigs.map((c) => c.id)) + 1
        : 1;
      while (newConfigs.length < target) {
        newConfigs.push(createEmptyConfig(nextId++));
      }
      setAdditionalConfigs(newConfigs);
    } else {
      // Trim configs from the end to match quantity
      setAdditionalConfigs((prev) => prev.slice(0, target));
    }
  }, [quantity, configsInitialized]);

  const email = userInfo.username;
  const mutation_cart = useMutation((post) => getMyCart(post, token), {
    onSuccess: (result) => {
      setMyCartMini(result);
    },
    onError: (error) => {},
  });
  useEffect(() => {
    const obj = {
      email: userInfo.username,
      dealerId: dealerId,
      minicart: true,
    };
    // mutation_cart.mutate(obj);
    // setPof({
    //   trecord,
    //   record,
    //   offset,
    //   box,
    //   start,
    // });
  }, []);

  const handleAddToShoppingList = () => {
    const arr1 = [];
    // Build otherNotes from multi-config (same structure as handleAddToCart)
    if (partData?.additionalInfoFlag && additionalConfigs.length > 0) {
      additionalConfigs.forEach((config, index) => {
        arr1.push({
          label: `Configuration ${index + 1}`,
          fields: Object.entries(config.fields).map(([title, value]) => ({
            title,
            value,
          })),
        });
      });
    }

    const arr = {
      partId: partData?.partId,
      quantity: quantity <= 0 ? 1 : quantity,
      date: getCurrentDate(),
      notes: "",
      userId: myProfile?.profileInfo?.id,
      other_notes: arr1,
      isPartDetail: true,
    };
    if (!disableBut) {
      mutation.mutate(arr);
    }
  };

  const handleAddToCart = () => {
    const arr1 = [];
    //Build configurations array for multi-config payload
    if (partData?.additionalInfoFlag && additionalConfigs.length > 0) {
      additionalConfigs.forEach((config, index) => {
        arr1.push({
          label: `Configuration ${index + 1}`,
          fields: Object.entries(config.fields).map(([title, value]) => ({
            title,
            value,
          })),
        })
      });
    };

    const arr = {
      partId: partData?.partId,
      userId: myProfile?.profileInfo?.id,
      quantity:  quantity <=0 ? 1 :quantity,
      notes: "",
      otherNotes: arr1,
    };
    let obj = [];
    obj.push(arr);
    let data = {
      email: userInfo?.username,
      update: false,
      isPartDetail: true,
      items: obj,
    };
    if (!disableBut) {
      mutationCart.mutate(data);
    }
  };

  const handleAddInfo = (item, val) => {
    const obj = { ...addinfoText };
    obj[item] = val;
    setaddinfoText(obj);
  };

  const notify = () => toast.success("Product added to cart");
  const notifyShop = () => toast.success("Product added to Shopping list");

  const mutation = useMutation((post) => updateWishList(post, token), {
    onSuccess: (result) => {
      setShopListPop(result?.data?.data);
      setIsModalOpenShop(true);
      // notifyShop();

      // Persist configs instead of clearing to default after successful add-to-shopping-list
      if (partData?.additionalInfoFlag && additionalConfigs.length > 0) {
        const configsToStore = additionalConfigs.map((config, index) => ({
          label: `Configuration ${index + 1}`,
          fields: Object.entries(config.fields).map(([title, value]) => ({
            title,
            value,
          })),
        }));
        setAddToCartConfigs(partData.partId, configsToStore);
      }
    },
    onError: (error) => {},
  });

  const mutationCart = useMutation((post) => addToCart(post, token), {
    onSuccess: (result) => {
      // notify();
      const obj = {
        email: userInfo.username,
        dealerId: dealerId,
        minicart: true,
      };
      setShopListPop(result?.data?.cart?.items);
      setIsModalOpen(true);
      mutation_cart.mutate(obj);

      // Persist configs from response instead of clearing to default
      if (partData?.additionalInfoFlag && additionalConfigs.length > 0) {
        const responseItems = result?.data?.cart?.items;
        const matchingItem = responseItems?.find(
          (item) => item.partId === partData?.partId
        );
        // otherNotes is an object keyed by user identifier, extract the first value (configs array)
        let responseConfigs = null;
        if (matchingItem?.otherNotes && typeof matchingItem.otherNotes === 'object') {
          const keys = Object.keys(matchingItem.otherNotes);
          if (keys.length > 0) {
            responseConfigs = matchingItem.otherNotes[keys[0]];
          }
        }
        // Store configs from response if available, otherwise keep current configs
        const configsToStore = responseConfigs || additionalConfigs.map((config, index) => ({
          label: `Configuration ${index + 1}`,
          fields: Object.entries(config.fields).map(([title, value]) => ({
            title,
            value,
          })),
        }));
        setAddToCartConfigs(partData.partId, configsToStore);
      }
    },
    onError: (error) => {},
  });

  useEffect(() => {
    setKeyWordFinal("");
    setKeyWord("");
  }, []);

  // useEffect(() => {
  //   handleVarientChange(selected)
  // }, [selected])

  const handleVarientChange = (selected) => {
    setSelected(selected);
  };

  useEffect(() => {
    partDetail?.data?.data?.data?.forEach((obj, index) => {
      if (obj?.partId === selected?.value) {
        setpartData(partDetail?.data?.data?.data[index]);
        if (
          partDetail?.data?.data?.data[index] &&
          partDetail?.data?.data?.data[index].additionalInfoFlag
        ) {
          setIsDiable(true);
        }
      } else {
        // setpartData(partDetail?.data?.data?.data[0]);
      }
    });
  }, [selected]);

  useEffect(() => {
    let disable = false;
    if (partData?.additionalInfoFlag && partData?.additionalInfo.length > 0) {
      // Multi-config validation
      if (additionalConfigs.length > 0) {
        disable = !areAllConfigsValid();
      } else if (addinfoText) {
        // Legacy flat validation fallback
        let arr = Object.values(addinfoText);
        let count = 0;
        if (arr && arr.length > 0) {
          arr.forEach((item) => {
            if (item !== "") {
              count += 1;
            }
          });
        }
        if (count === partData?.additionalInfo.length) {
          disable = false;
        } else {
          disable = true;
        }
      }
    }
    setIsDiable(disable);
  }, [addinfoText, additionalConfigs]);

  useEffect(() => {
    // if (currentDevice !== "Mobile") {
      setShow(false);
      setTimeout(() => {
        setShow(true);
      }, 2000);
    // }
  }, []);

  return (
    <Grid container direction="column">
            <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        aria-labelledby="add-to-cart-modal"
        aria-describedby="add-to-cart-modal-description"
      >
        <div className="addToCart-modal">
          <AddToCartPopUp
            shopList={shopListPop}
            setIsModalOpen={setIsModalOpen}
            isModalOpen={isModalOpen}
            isLoading={mutation_cart.isLoading}
          />
        </div>
      </Modal>
      <Modal
        open={isModalOpenShop}
        onClose={() => setIsModalOpenShop(false)}
        aria-labelledby="add-to-cart-modal"
        aria-describedby="add-to-cart-modal-description"
      >
        <div className="addToCart-modal">
          <AddToShopPop
            setIsModalOpen={setIsModalOpenShop}
            shopList={shopListPop}
            yourCart={true}
            isModalOpen={isModalOpenShop}
          />
        </div>
      </Modal>
      {load && <Loader></Loader>}
      {load && <Loader></Loader>}
      <Grid item>
        <Header page="Catalog"></Header>
        <PartsCatalog />
      </Grid>
      <Grid item>
        <Grid container>
          <div className="partsDetailMainComponent">
            <Grid item md={5}>
              <div className={`partsDetailLeftSideComponent__mainDesktop`}>
                <div className={`partsDe_container1Desktop`}>
                  <Link className={`partsDe_catalogLinkDesktop`} to="/catalog">
                    <p>Catalog</p>
                  </Link>{" "}
                  <span className="ferltjngrtujik">/</span>
                  <p
                    style={{
                      cursor: "pointer",
                      color: "#ce0e2d",
                      fontFamily: "Montserrat",
                      fontSize: "14px",
                      textDecoration: "underline ",
                      fontWeight: "700",
                    }}
                    onClick={() => {
                      navigate({
                        pathname: "/catalog",
                      });
                    }}
                  >
                    {globalcategoryIdCatalog}
                  </p>{" "}
                  <Link className={`partsDe_TransmissionLinkDesktop`}>
                    <p>{partData?.primaryCategoryName}</p>
                  </Link>
                </div>
                <div className={`partsDe_container2Desktop`}>
                  <div className={`partsDe_nameDesktop`}>
                    {partData?.partName}
                  </div>
                </div>
                {isCurrentEngSet && (
                  <>
                    {partData?.isEngineCompartible ? (
                      <div className={`partsDe_compatibilityMsgBoxDesktop`}>
                        <Checkmark
                          className={`partsDe_checkMarkDesktop`}
                        ></Checkmark>
                        <p className={`partsDe_NOTcompatibilityMsg`}>
                          Compatible with current engine
                        </p>
                      </div>
                    ) : (
                      <div className="partsDe_NOTcompatibilityMsgBox">
                        <Exclamation className="partsDe_exclamationMark"></Exclamation>
                        <p className="partsDe_NOTcompatibilityMsg">
                          Not compatible with current engine
                        </p>
                      </div>
                    )}
                  </>
                )}

                {/* <div className={`partsDe_colorBoxDesktop`}>
            <p className={`partsDe_colorLabelDesktop`}>COLOR</p>
            <br></br>
           
          </div> */}
                {/* stateRef.current.setValue("StateProvince",null) */}
                {partDetail?.data?.data?.varientDrodown &&
                  partDetail?.data?.data?.varientDrodown?.length > 0 && (
                    <>
                      <Box sx={{ marginTop: "10px", fontWeight: "700" }}>
                        {partDetail?.data?.data?.variantDropdownName}

                        {partDetail?.data?.data?.varientDrodown?.length ==
                          1 && (
                          <span style={{ marginLeft: "12px" }}>
                            {partDetail?.data?.data?.varientDrodown[0]?.label}
                          </span>
                        )}
                      </Box>
                      {!disableBut &&
                      partDetail?.data?.data?.varientDrodown &&
                      partDetail?.data?.data?.varientDrodown?.length > 1 ? (
                        <Box
                          sx={{
                            marginTop: "2px",
                          }}
                          className="margInBottomLine"
                        >
                          <div className="seloptdiv">
                            <span className="selopt">Select an option</span>
                          </div>
                          <Select
                            isLoading={partDetail?.isFetching}
                            onChange={handleVarientChange}
                            value={selected}
                            styles={customStyles}
                            //  defaultValue= { defaultSelected}
                            options={varrientDropdown}
                          />
                        </Box>
                      ) : (
                        <>
                          {/* <Box>{ partDetail?.data?.data?.varientDrodown[0]?.label}</Box> */}
                        </>
                      )}
                    </>
                  )}

                <div className={`parstsDe_PARTinfoDesktop`}>
                  <h3 className={`partsDe_code1Desktop`}>PART#</h3>
                  <h3 className={`partsDe_code2Desktop`}>
                    {partData?.partNumber}
                  </h3>
                  <h3 className={`partsDe_code2_mobDesktop`}>501-0018-RED</h3>
                  <h3 className={`partsDe_code3_mobDesktop`}>
                    {/* (Replaces Part# <span className="code3">PE01318</span>){" "} */}
                  </h3>
                    {partData?.isSupercedeDiscontinue?.status ? (
                              <Box
                                sx={{
                                  fontWeight: "700",
                                  fontSize: "12px",
                                  display: "flex",
                                  marginLeft:"auto"
                                }}
                                
                              >
                                <div className="divSkuTile mt" style={{ color: "#CE0E2D"  }}>
                                  {`${"This part is a replacement for "} `}
                                  {partData?.isSupercedeDiscontinue?.replacementPartNumber &&
                                    partData?.isSupercedeDiscontinue?.replacementPartNumber.length >
                                      0 &&
                                    partData?.isSupercedeDiscontinue?.replacementPartNumber.map(
                                      (itemName, i) => (
                                        <>
                                          {i < 4 ? (
                                            <>
                                              <span
                                                style={{ color: "#CE0E2D" ,marginLeft:"4px"}}
                                                key={itemName}
                                              >{itemName}</span>
                                              {i !==
                                                partData?.isSupercedeDiscontinue
                                                  ?.replacementPartNumber.length -
                                                  1 && <span>{`, `}</span>}
                                            </>
                                          ) : (
                                            <>
                                              <span>...</span>
                                            </>
                                          )}
                                        </>
                                      )
                                    )}
                                </div>
                              </Box>
                            ) : (
                              ""
                            )}
                </div>
               
                <div className={`partsDe_container3Desktop`}>
                  <Grid
                    sx={{ marginTop: "10px", gap: "10px" }}
                    container
                    columnSpacing={2}
                  >
                    {partData?.additionalInfoFlag && (
                      <Grid
                        item
                        sx={{
                          flexDirection: "row",
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                        md={12}
                      >
                        <div className="partDetailTitile">
                          {`${commonMessages?.partDetailSubHeadingThree}`}
                          <span className="red">*</span>{" "}
                        </div>
                        <span className="config-helper-text">
                          You can add up to {MAX_CONFIGS} configurations
                        </span>
                      </Grid>
                    )}

                    {/* --- Multi-Configuration Cards --- */}
                    {partData?.additionalInfoFlag &&
                      additionalConfigs.map((config, configIndex) => (
                        <Grid item md={12} key={config.id} className="config-card">
                          <div className="config-card-header">
                            <span className="config-card-title">
                              Configuration {configIndex + 1}
                            </span>
                            {additionalConfigs.length > 1 && (
                              <button
                                type="button"
                                className="config-remove-btn"
                                onClick={() => handleRemoveConfig(config.id)}
                                aria-label={`Remove configuration ${configIndex + 1}`}
                              >
                                &times; Remove
                              </button>
                            )}
                          </div>
                          <div className="config-card-fields">
                            {partData?.additionalInfo.map((fieldName) => (
                              <div className="config-field" key={fieldName}>
                                <div className="reDenter">
                                  <div className="labelPartDetail">{fieldName}</div>
                                  <span className="red">*</span>
                                </div>
                                <input
                                  className="InputFieldShippingAddressPayment"
                                  onChange={(event) => {
                                    handleConfigFieldChange(
                                      config.id,
                                      fieldName,
                                      event.target.value
                                    );
                                  }}
                                  value={config.fields[fieldName] || ""}
                                  type="text"
                                  name={`config-${config.id}-${fieldName}`}
                                  placeholder={fieldName}
                                />
                              </div>
                            ))}
                          </div>
                        </Grid>
                      ))}

                    {/* Add Configuration button */}
                    {partData?.additionalInfoFlag && additionalConfigs.length < MAX_CONFIGS && (
                      <Grid md={12}>
                        <button
                          type="button"
                          className="config-add-btn"
                          onClick={handleAddConfig}
                          disabled={additionalConfigs.length >= MAX_CONFIGS}
                        >
                          + Add Configuration
                        </button>
                      </Grid>
                    )}

                    {partData?.additionalInfoFlag && additionalConfigs.length >= MAX_CONFIGS && (
                      <span className="max-qty-msg" style={{ color: "#ce0e2d" }}>
                        You can only add up to {MAX_CONFIGS} configurations
                      </span>
                    )}

                    <Grid
                      item
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        gap: "10px",
                      }}
                      md={12}
                    >
                      {/* <Grid item md={3}>
                    <div className="labelPartDetail">Hours *</div>
                    <input
                      className={`InputFieldShippingAddressPayment`}
                      type="text"
                      name="firstname"
                    ></input>
                  </Grid> */}
                    </Grid>
                  </Grid>

                  {(myProfile?.profileInfo?.permissions?.includes(
                    "add_to_own_cart"
                  ) || dealerId) && !partData?.isDiscontinue?.status ? (
                    <div className={`partsDe_container3msgDesktop`}>
                      {partData?.productEffectiveCost !==
                        partData?.productOrigionalCost && addCommaDecimal(partData?.productOrigionalCost) &&  (
                        <>
                          <h4 className={`partsDe_container3_msg1Desktop`}>
                            Special Price for {partData?.dealerLevel} Dealers
                          </h4>
                          <br></br>
                          <p className={`partsDe_container3_msg2Desktop sdsds`}>
                            (Regular $
                            {addCommaDecimal(partData?.productOrigionalCost)}
                            )
                          </p>
                        </>
                      )}
                    </div>
                  ) : (
                    <div className="margingwholepart"> </div>
                  )}
                  <div
                    className={`partsDe_container3_inputBoxPriceCartDesktop`}
                    style={{ flexWrap:'wrap'}}
                  >
                    {(myProfile?.profileInfo?.permissions?.includes(
                      "add_to_own_cart"
                    ) ||
                      dealerId) && !partData?.isDiscontinue?.status && (
                      <div className={`partsDe_container3_priceDesktop`}>
                        {"$" +
                          parseFloat(
                            partData?.productEffectiveCost
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      </div>
                    )}
                     <Tooltip
                      placement="right"
                      title={
                        mes
                          ? "Variants do not exist for this product. Please contact Ilmor for further assistance."
                          : ""
                      }
                    >
                      {!dealerId && (
                        <>
                        <Box
                          className="center"
                          sx={{
                            marginLeft: currentDevice !== "Mobile" && "-173px",
                          }}
                        >
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <NumericInput
                              className={`partDetails_InputFieldDesktop`}
                              mobile={false}
                              strict
                              max={partData?.additionalInfoFlag ? MAX_CONFIGS : 999}
                              // min={1}
                              value={quantity <= 0 ? "" : quantity}
                              onChange={handleInputChangeSelect}
                              onBlur={(event) => {
                                if (
                                  event.target.value == "" ||
                                  event.target.value <= 0
                                ) {
                                  handleInputChangeSelect(1);
                                } else if (
                                  partData?.additionalInfoFlag &&
                                  event.target.value > MAX_CONFIGS
                                ) {
                                  handleInputChangeSelect(MAX_CONFIGS);
                                }
                              }}
                            />
                          </div>
                          <div
                            className={classnames(
                              "iconWrapper center bgForCart",
                              {
                                disableBut: disableBut || partData?.doNotSell,
                              }
                            )}
                          >
                            {mutation.isLoading ? (
                              <CircularProgress
                                style={{ color: "white" }}
                                size={20}
                              />
                            ) : (
                              <GreyShopList
                                onClick={handleAddToShoppingList}
                                className="GreyShopList icon"
                              ></GreyShopList>
                            )}
                          </div>
                          {myProfile?.profileInfo?.permissions?.includes(
                            "add_to_own_cart"
                          ) && (
                            <div
                              className={classnames(
                                "iconWrapper center bgForCart",
                                {
                                  disableBut: disableBut || partData?.doNotSell,
                                }
                              )}
                            >
                              {mutationCart.isLoading ? (
                                <CircularProgress
                                  style={{ color: "white" }}
                                  size={20}
                                />
                              ) : (
                                <RedCart
                                  onClick={handleAddToCart}
                                  // className="redCartHover"
                                  className="GreyShopList icon"
                                ></RedCart>
                              )}
                            </div>
                          )}
                        </Box>
                         <div style={{display: 'flex', flex:'1 0 100%', fontSize: '12px', fontWeight: '700'}} className="mt5">
                          {
                            partData?.partStatus && !partData?.isDiscontinue?.status ? (
                              <div style={{color:'#40A900', marginRight: '5px'}}>
                                {formatPartStatus(partData?.partStatus)}
                              </div>
                            ) : ""
                          }
                          {
                            partData?.message ? <div style={{color:'#CE0E2D'}}>{`(${partData?.message})`}</div> : ""
                          }
                          </div>
                          <div>
                            {partData?.additionalInfoFlag && quantity >= MAX_CONFIGS && (
                              <div className="max-qty-msg">max qty is {MAX_CONFIGS}</div>
                            )}
                          </div>
                        </>
                      )}
                    </Tooltip>

                  </div>
                </div>

                {/* <div className={`partsDe_lineBreakDesktop`}></div> */}

                {/* Temporary flag to hide compatible engines section (heading, items container, and top border) */}
                {tempShowCompatibleEngines &&
                  partData &&
                  partData?.engineCompartabiltiy &&
                  partData?.engineCompartabiltiy.length > 0 && (
                    <div className={`partsDe_container4Desktop borderPart`}>
                      <h4 className={`partsDe_container4_msgDesktop`}>
                        {commonMessages?.partDetailHeading}
                      </h4>
                      <div className={`partsDe_container4_engineNamesDesktop`}>
                        <div
                          className={`partsDe_container4_engineNamesListDesktop`}
                        >
                          <ul
                            className={`partsDe_container4_engineNameDesktop`}
                          >
                            {partData &&
                              partData?.engineCompartabiltiy &&
                              partData?.engineCompartabiltiy.length > 0 &&
                              partData?.engineCompartabiltiy.map((item) => {
                                return <li className="lipat sdsds">{item}</li>;
                              })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                {/* <div className={`partsDe_lineBreakDesktop`}></div> */}
                { partData?.toolNotes ? <div className="partsDe_container3_msg1Desktop_detail"> <h4 className={`partsDe_container3_msg1Desktop`}>TOOL LIST</h4> <div dangerouslySetInnerHTML={{__html: partData?.toolNotes}} /></div> :""}
                {partData?.torqueSpecification ?<div className="partsDe_container3_msg1Desktop_detail"> <h4 className={`partsDe_container3_msg1Desktop`}>TORQUE SPECIFICATIONS</h4> <div dangerouslySetInnerHTML={{__html: partData?.torqueSpecification}} /> </div>: ""}
              

                {partData?.description && (
                  <div className={`partsDe_descriptionDesktop btop`}>
                    <span className={`partsDe_descriptionLabelDesktop`}>
                      Description
                    </span>
                    <span className={`partsDe_descriptionMsgDesktop fnt`}>
                      {partData?.description && partData?.description.length > 2000 ? `${partData?.description.slice(0,2000)}...` : partData?.description }
                    </span>
                  </div>
                )}

                {/* <div className={`partsDe_lineBreakDesktop`}></div> */}
                <div className="customAccordion">
                { partData?.removalSteps ?     <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          className="partsDe_container_Desktop"
        >
          <h4 component="span" >REMOVAL STEPS</h4>
        </AccordionSummary>
        <AccordionDetails>
        <div dangerouslySetInnerHTML={{__html:partData?.removalSteps}}/>
        </AccordionDetails>
      </Accordion> : ""}
    { partData?.installationRequirements ? <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          className="partsDe_container_Desktop"
        >
       <h4 component="span" >INSTALLATION STEPS</h4>
        </AccordionSummary>
        <AccordionDetails>
         <div dangerouslySetInnerHTML={{__html:partData?.installationRequirements}}/>
        </AccordionDetails>
      </Accordion> : ""}
      </div>

                <div className={`partsDe_container5Desktop btop`}>
                  <div className={`partsDe_container5MsgBoxDesktop`}>
                    <div className={`partsDe_footerDescripDesktop`}>
                      <div className={`partsDe_container5MsgDesktop fnt`}>
                        <Warning
                          className={`partsDe_warningIconOutlinedDesktop`}
                        ></Warning>
                        <b> WARNING: </b>
                        {commonMessages?.partDetailWarning}
                        {/* {partData?.description} */}
                        <span
                          onClick={() => {
                            window.open(
                              "https://www.p65warnings.ca.gov/marine",
                              "_blank"
                            );
                          }}
                          className={`partsDe_container5LinkDesktop fnt`}
                        >
                          {" "}
                          {commonMessages?.partDetailWebsite}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
            {partData?.images && partData?.images.length > 0 ? (
              <Grid className="center rightImageSection" item md={7}>
                <div
                  className={classnames("partsDetailCorousalComponent", {
                    dpcar: !show,
                  })}
                >
                  <Carousal images={partData?.images}></Carousal>
                </div>
                <div
                  className={classnames("partsDetailCorousalComponent center", {
                    dpcar: show,
                  })}
                >
                  <img
                    // className={`card__imageDesktop`}
                    className={classnames("jdfhgdhjf454 ", {
                      // dpcar: !show,
                    })}

                    // onLoad={handleLoad}
                    // onError={handleError}
                    // style={{ display: isLoading || hasError ? "none" : "block" }}
                    src={partData?.images[0]}
                    alt={"Ilmor Part Image"}
                  />
                  {/* <div className="bar">
                    <div className="barthumb"></div>
                  </div> */}
                </div>
              </Grid>
            ) : (
              <Grid className="center" item md={7}>
                <img
                  // className={`card__imageDesktop`}
                  // onLoad={handleLoad}
                  // onError={handleError}
                  // style={{ display: isLoading || hasError ? "none" : "block" }}
                  src={place}
                  alt={"Ilmor Part Image"}
                />
              </Grid>
            )}
          </div>
        </Grid>
      </Grid>
      <Footer></Footer>
    </Grid>
  );
};

export default PartsDetail;
